import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './VipRenewal.module.css';

const VipRenewal = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState(null);

  const plans = [
    {
      id: 'monthly',
      name: '月费会员',
      price: '4.9',
      unit: '月',
      period: '1个月',
      features: [
        '无限章节阅读',
        '无限收藏单词 / 句子',
        '无限添加学习笔记',
        '章节 PDF 下载',
      ],
    },
    {
      id: 'yearly',
      name: '年费会员',
      price: '39',
      unit: '年',
      period: '12个月',
      badge: '推荐',
      savings: '节省 ¥19.8',
      features: [
        '无限章节阅读',
        '无限收藏单词 / 句子',
        '无限添加学习笔记',
        '章节 PDF 下载',
        '优先客服支持',
      ],
    },
  ];

  // 免费用户 vs VIP 对比数据
  const comparisons = [
    { label: '每日阅读章节', free: '2 章 / 天', vip: '无限制', icon: 'menu_book' },
    { label: '每日收藏单词', free: '10 个 / 天', vip: '无限制', icon: 'translate' },
    { label: '每日收藏句子', free: '5 条 / 天', vip: '无限制', icon: 'format_quote' },
    { label: '每日添加笔记', free: '3 条 / 天', vip: '无限制', icon: 'edit_note' },
    { label: '章节 PDF 下载', free: '—', vip: '支持', icon: 'download' },
  ];

  const handleSelectPlan = (planId) => {
    setSelectedPlan(planId);
  };

  const handlePayment = () => {
    if (!selectedPlan) {
      alert('请先选择会员套餐');
      return;
    }
    // TODO: 跳转到支付页面或调用支付接口
    alert(`即将开通 ${plans.find(p => p.id === selectedPlan)?.name}`);
  };

  return (
    <div className={styles.vipRenewal}>
      <div className={styles.header}>
        <button 
          className={styles.backBtn}
          onClick={() => navigate(-1)}
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>会员续费</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.hero}>
          <div className={styles.heroIcon}>
            <span className="material-symbols-outlined">workspace_premium</span>
          </div>
          <h2 className={styles.heroTitle}>升级 VIP 会员</h2>
          <p className={styles.heroDesc}>解锁全部功能，享受无限学习体验</p>
        </div>

        {/* 套餐选择 */}
        <div className={styles.plans}>
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`${styles.planCard} ${selectedPlan === plan.id ? styles.planCardSelected : ''}`}
              onClick={() => handleSelectPlan(plan.id)}
            >
              {plan.badge && (
                <div className={styles.planBadge}>{plan.badge}</div>
              )}
              
              <div className={styles.planHeader}>
                <h3 className={styles.planName}>{plan.name}</h3>
                <div className={styles.planPrice}>
                  <span className={styles.planPriceSymbol}>¥</span>
                  <span className={styles.planPriceAmount}>{plan.price}</span>
                  <span className={styles.planPriceUnit}>/{plan.unit}</span>
                </div>
                {plan.savings && (
                  <p className={styles.planSavings}>{plan.savings}</p>
                )}
                <p className={styles.planPeriod}>{plan.period}</p>
              </div>

              <div className={styles.planFeatures}>
                {plan.features.map((feature, index) => (
                  <div key={index} className={styles.planFeature}>
                    <span className={`material-symbols-outlined ${styles.featureIcon}`}>
                      check_circle
                    </span>
                    <span className={styles.featureText}>{feature}</span>
                  </div>
                ))}
              </div>

              <div className={styles.planRadio}>
                <div className={`${styles.radio} ${selectedPlan === plan.id ? styles.radioChecked : ''}`}>
                  {selectedPlan === plan.id && (
                    <div className={styles.radioInner}></div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 免费 vs VIP 对比表 */}
        <div className={styles.comparisonSection}>
          <h3 className={styles.comparisonTitle}>
            <span className="material-symbols-outlined">compare</span>
            免费用户 vs VIP 会员
          </h3>
          <div className={styles.comparisonTable}>
            <div className={styles.comparisonHeader}>
              <span className={styles.comparisonColLabel}>功能</span>
              <span className={styles.comparisonColFree}>免费</span>
              <span className={styles.comparisonColVip}>VIP</span>
            </div>
            {comparisons.map((item, index) => (
              <div key={index} className={styles.comparisonRow}>
                <span className={styles.comparisonLabel}>
                  <span className={`material-symbols-outlined ${styles.comparisonIcon}`}>{item.icon}</span>
                  {item.label}
                </span>
                <span className={styles.comparisonFree}>{item.free}</span>
                <span className={styles.comparisonVip}>
                  <span className={`material-symbols-outlined ${styles.comparisonCheck}`}>check</span>
                  {item.vip}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.footer}>
          <button
            className={styles.payBtn}
            onClick={handlePayment}
            disabled={!selectedPlan}
          >
            立即开通
          </button>
          <p className={styles.footerNote}>
            开通会员即表示您同意我们的<a href="/terms#terms">服务条款</a>和<a href="/terms#privacy">隐私政策</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VipRenewal;


